import { UICommandContext } from "../../../library-js/dom-ui/commands/UICommandContext";
import { UICommand } from "../../../library-js/dom-ui/commands/UICommand";
import { UICommandManager } from "../../../library-js/dom-ui/commands/UICommandManager";
import { NodeGraph } from "../model/NodeGraph";
import { Delete } from "./Delete";
import { NGCommand } from "./NGCommand";
import { NGCommandContext } from "./NGCommandContext";


export class NGCommandManager extends UICommandManager<NGCommandContext,NGCommand>
{
  _nodeGraph:NodeGraph;

  constructor( ng:NodeGraph )
  {
    super();
    this._nodeGraph = ng;
    
  }

  readonly delete:Delete = new Delete( this );
}